import React, { useContext } from "react";
import AddButton from "./AddButton";
import Price from "./Price.jsx";
import CartContext from "../../context/CartContext";
import PopupContext from "../../context/PopupContext";
import SearchContext from "../../context/SearchContext";
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';


const ProductItem = ({ product }) => {
  const cartCtx = useContext(CartContext);
  const searchCtx = useContext(SearchContext);
  const popupCtx = useContext(PopupContext);
  const handleAddItem = () => {
    cartCtx.addItem(product);
  };

  const handleRemoveItem = () => {
    cartCtx.removeItem(product.id, 1);
  };

  const subTotal = (product.specialprice || product.price) * (product.qty || 0);

  return (
    <>
      <div className="list-item" key={product.id}>
        <>
          <TableRow
            key={product.id}
            className="productItem product-row"
          >
            <TableCell
              className="cell-image cell-content-center"
            >
              {product.image && (
                <img
                  src={product.image}
                  alt={product.productname}
                  className="product-img"
                  // onClick={() => {
                  //   if (!searchCtx.isSearchEnabel) {
                  //     popupCtx.openProductPopup(product);
                  //   }
                  // }}
                />
              )}
            </TableCell>

            <TableCell
              className="cell-name"
              style={{ textAlign: 'left', height: '-webkit-fill-available' }}
            >
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '4px',
                justifyContent: 'flex-start',
                flexWrap: 'nowrap',
              }}>
                <div
                  style={{
                    maxWidth: 'max-content',
                    overflow: 'hidden',
                    color: '#282828',
                  }}
                  dangerouslySetInnerHTML={{ __html: product.productname }}
                />
              </div>
            </TableCell>

            <TableCell
              className="cell-price cell-content-center"
            >
              <div className="price-stack">
                <div className="special-price">₹{product.specialprice || product.price}</div>
                <strike className="original-price">₹{product.price}</strike>
              </div>
            </TableCell>

            <TableCell
              className="cell-action cell-content-center"
            >
              <AddButton
                qty={product.qty}
                add={handleAddItem}
                remove={handleRemoveItem}
              />
            </TableCell>

            <TableCell
              className="cell-subtotal cell-content-center"
            >
              <div className="subtotal-price">
                {subTotal.toFixed(2)}
              </div>
            </TableCell>
          </TableRow>
        </>
      </div >

    </>
  );
};

export default ProductItem;